import TpWidgetSlider from "./TpWidgetSlider";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

const ReviewCard = ({ data }) => {
  return (
    <li className="review-card">
      <div className="review-from">{data.from}</div>
      <p>{data.text}</p>
      <cite>―{data.name}</cite>
    </li>
  );
};
const RatingCard = ({ data }) => {
  return (
    <li className="rating-card">
      <i dangerouslySetInnerHTML={{ __html: data.icon }}></i>
      <p>
        <strong>{data.rating}</strong> {data.text}
      </p>
    </li>
  );
};
const BadgingCard = ({ data }) => {
  return (
    <li className="review-card fx lg:px-2 lg:py-2 md:py-2">
      <div className="card--default md:fx">
        <figure>
          <img loading="lazy" src={data.image.src} alt={data.image.alt} />
        </figure>
        <div className="lg:ml-2 lg:mt-2 md:mt-1.5">
          <p className="review-from fw-600">{data.name}</p>
          <p className="text-smx">{data.category}</p>
        </div>
      </div>
    </li>
  );
};
const PeopleCard = ({ data, bg, imgClasses }) => {
  return (
    <li className={`client-card boxshadow-none lg:px-0 lg:py-0 md:px-0 ${bg}`}>
      <figure>
        <figcaption className="lg:d-fx lg:pt-3 lg:px-3 md:d-fx md:px-3">
          <span className="quot-glyph lg:mt-0 md:mt-0">“</span>
          <p
            className="text-md"
            dangerouslySetInnerHTML={{ __html: data.text }}
          ></p>
        </figcaption>
        <picture>
          <source
            srcSet={`${data.image.src}.webp, 
            ${data.image.src}@2x.webp 2x`}
            type="image/webp"
          />
          <source
            srcSet={`${data.image.src}.png, 
            ${data.image.src}@2x.png 2x `}
            type="image/png"
          />
          <img
            loading="lazy"
            src={`${data.image.src}.png`}
            alt={data.image.alt}
            className={imgClasses}
            width="100%"
            height="100%"
          />
        </picture>
      </figure>
    </li>
  );
};
export default function Masonry({ data, className = "", hasTpWidget = false }) {
  return (
    <section className={`industry-masonry ${className}`}>
      <h2 className="people-love-setmore container text-xl text-center lg:mb-9 md:mb-5">
        <span>People</span>{" "}
        <span className="md:d-block lg:ml-1 lg:mr-1">❤️</span>{" "}
        <span>Setmore</span>
      </h2>
      {hasTpWidget && <TpWidgetSlider />}
      <article className="container card--default card--masonry">
        <ul>
          <ReviewCard data={data.reviews.rowena} />
          <PeopleCard
            data={data.people.one}
            bg="bg-yellow"
            imgClasses="lg:-mt-10 lg:mt-4 lg:pl-4 lg:pt-10 lg:w-auto md:-mt-5 md:ml-4 md:pt-4 md:w-75"
          />

          <BadgingCard data={data.badges.capterra} />
        </ul>
        <ul>
          <RatingCard data={data.ratings.facebook} />
          <ReviewCard data={data.reviews.christine} />
          <RatingCard data={data.ratings.capterra} />
          <ReviewCard data={data.reviews.holly} />
        </ul>
        <ul>
          <PeopleCard
            data={data.people.two}
            bg="bg-green"
            imgClasses="lg:-mt-9 lg:pt-9 lg:px-10 lg:w-auto md:-mt-5 md:ml-7 md:pt-4 md:px-1 md:w-75"
          />
          <ReviewCard data={data.reviews.jorgen} />
          <BadgingCard data={data.badges.getapp} />
        </ul>
      </article>
      <style jsx>
        {`
          @media (max-width: ${viewport.tablet.sm}) {
            .card--masonry {
              width: 90%;
            }
            .card--masonry > ul {
              max-width: 100%;
              margin-right: 0px;
              margin-left: 0px;
            }
          }
        `}
      </style>
    </section>
  );
}
